import { useTranslation } from "react-i18next"

const BusinessUnitDeleteModal = ({
    modalId,
    businessUnitInfo,
    onDelete = () => { }
}) => {

    const [t] = useTranslation("global")

    let closeButtonId = `closeModalButton_${modalId}`
    const closeModal = () => { document.getElementById(closeButtonId).click() }

    const handleDelete = () => {
        closeModal()
        onDelete(businessUnitInfo.businessUnit.guid)
    }

    return (
        <div className="modal fade " id={modalId} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content bg-dark">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">{t("helper.confirm_request")}</h1>
                        <button type="button" className="btn-close bg-light" id={closeButtonId} data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body bg-black bg-opacity-25">
                        {t("helper.generic_entity_deleting")}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal"> {t("action.cancel")}</button>
                        <button type="button" className="btn btn-danger" onClick={handleDelete}><i className="fa-solid fa-trash"></i> {t("action.delete")}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BusinessUnitDeleteModal